import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Icon } from '../common/Icons';
import Plyr from 'plyr-react';
import 'plyr-react/dist/plyr.css';
import { StyledContainer, StyledIframeWrap, StyledCloseBtn } from './IframePopUp.styles';

function IframePopUp({ source, provider, onClose }) {
  const plyrRef = useRef();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <StyledContainer>
      <StyledCloseBtn onClick={onClose}>
        <Icon.Close />
      </StyledCloseBtn>
      <StyledIframeWrap>
        <Plyr
          ref={plyrRef}
          source={{
            type: 'video',
            title: 'Video title',
            sources: [
              {
                src: source || '',
                type: provider,
                provider: provider || '',
              },
            ],
          }}
          options={{
            autoplay: true,
          }}
        />
      </StyledIframeWrap>
    </StyledContainer>
  );
}

IframePopUp.propTypes = {
  source: PropTypes.string,
  provider: PropTypes.string,
  onClose: PropTypes.func,
};

IframePopUp.defaultProps = {
  source: '',
  provider: '',
  onClose: () => {},
};

export default IframePopUp;
